import React,{forwardRef,useState,useEffect, useRef} from 'react'
import { connect } from "react-redux";
import styles from '../styles/settings.module.scss'
import gsap,{Power3} from 'gsap'
import LoaderWheel from './LoaderWheel'
import axios from 'axios'
import {setUser} from 'store/actions'
import Globals from 'system/Globals'
import store from '../../store';
import Switch from './Switch'
import AccountBlock from './AccountBlock';
import {ReactComponent as Pencil} from 'assets/icons/pencil.svg'
import ControllerServerComs from 'system/ControllerServerComs';
import Cookies from 'js-cookie';
import Modal from './Modal';

const Settings = forwardRef((props,ref)=>{
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    
    useEffect(() => {
        gsap.to(ref.current,{duration:0.35,ease:Power3.easeInOut,opacity:0.25})
        gsap.to(ref.current.querySelector('.loader-container svg'),{duration:0.5,scale:1,ease:Power3.easeInOut,opacity:1})
        console.log('props.showContSettings', props)
    }, [])
   

    function getInitSyncValue(){
        let strSync=localStorage.getItem('manualSync')
        return Boolean(strSync!=='false')
    }

    function getInitOfflineModeValue(){
        let mode= Globals.instance().offlineMode;
        let mode2=localStorage.getItem('offlineMode')
        console.log('getInitOfflineModeValue', mode, mode2)
        if (mode===null||mode===true||mode==='true'||mode2==='true') {
            return true
        }
        return false
    }

    function logout(){
        gsap.to(ref.current,{duration:0.25,ease:Power3.easeInOut,opacity:0,onComplete:(flogout)=>{flogout()}, onCompleteParams:[props.logout]})
        Globals.instance().downloaded = []
        localStorage.removeItem('expo.downloaded')

        function removeAllCookies() {
        const allCookies = Cookies.get(); // Get an object containing all cookies

        for (const cookieName in allCookies) {
            if (Object.hasOwnProperty.call(allCookies, cookieName)) {
            const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
            const cookieOptions = {
                sameSite: 'Lax'
            };
            
            if (isLocalhost) {
                // For localhost, don't set domain (defaults to current hostname)
                cookieOptions.secure = false; // Allow HTTP for local dev
            } else {
                // For production, use the expostudio.co domain
                cookieOptions.domain = '.expostudio.co';
                cookieOptions.secure = true; // Require HTTPS for production
            }

            Cookies.remove(cookieName, cookieOptions); 
            // If your cookies were set with specific path or domain, 
            // you need to provide those options to Cookies.remove()
            // e.g., Cookies.remove(cookieName, { path: '/', domain: '.yourdomain.com' });
            }
        }
        }
        removeAllCookies();

        if (Globals.instance().ios && !Globals.instance().controllerApp) {
            window.webkit.messageHandlers.notification.postMessage({ Object: "logout" });
            localStorage.setItem('expo.downloadAlert', [])
            
            localStorage.removeItem('user');
            
            Globals.instance().downloaded = []

            // localStorage.setItem('expo.downloaded', [])
        }

        if (Globals.instance().ios && Globals.instance().controllerApp) {
            // window.webkit.messageHandlers.notification.postMessage({ Object: "logout-controller" });
            ControllerServerComs.instance().postMessageFromControllerToIOS('backToStart','');
            localStorage.setItem('expo.downloadAlert', [])
            
            localStorage.removeItem('user');
            
            Globals.instance().downloaded = []

            // localStorage.setItem('expo.downloaded', [])
        }

        if (Globals.instance().electron) {
         
            localStorage.setItem('expo.downloadAlert', [])
            
            Globals.instance().downloaded = []

            // localStorage.setItem('expo.downloaded', [])
        }

    }
    function onChangeSync(val){
        localStorage.setItem('manualSync',JSON.stringify(val))
    }

    function onChangeOfflineMode(val){

        if (Globals.instance().noInternet && val === false) {
            Globals.instance().showAlert('No Internet Connection', 
                '<span style="text-align:center"><p>To switch back to online mode please reconnect to the internet first.</p></span>')
            
            return 
        }
        localStorage.setItem('offlineMode', JSON.stringify(val))
        if (Globals.instance().ios && !Globals.instance().controllerApp) {
            
            window.webkit.messageHandlers.notification.postMessage({ Object: 'offline-mode', Data: val })
            props.onClickClose();
            return
        }
    
        Globals.instance().offlineMode = val;
        if (val) {
            Globals.instance().useCMS = false;
            Globals.instance().useLocal = true;
        } else {
            Globals.instance().useCMS = true;
            Globals.instance().useLocal = false;
        }

        if (Globals.instance().electron) {
            setTimeout(() => {
                window.api.send("toApp", { event: "reload-app" });
            }, 200);
            
        }

        console.log('onChangeOfflineMode', val, Globals.instance().offlineMode, Globals.instance().useCMS, Globals.instance().useLocal)
    }   
    

    function getInitPrefFullScreenValue(){
        let strSync=localStorage.getItem('setpref-fullscreen')
        
        return Boolean(strSync!=='false')
    }

    function onChangePrefFullScreen(val) {
      
        localStorage.setItem('setpref-fullscreen',JSON.stringify(val))
        if(Globals.instance().electron){
            window.api.send("toApp", {"event":"setpref-fullscreen", "pref": val});
        }
        console.log('onChangePrefFullScreen', val)
 
    }


    function getInitPrefNavBoxValue(){
        let strSync=localStorage.getItem('setpref-navbox')
        return Boolean(strSync!=='false')
    }

    function onChangePrefNavBox(val) {
      
        localStorage.setItem('setpref-navbox',JSON.stringify(val))
        if(Globals.instance().electron){
            window.api.send("toApp", {"event":"setpref-navbox", "pref": val});
        }
        Globals.instance().prefNavBox = val;
        console.log('onChangePrefNavBox', val)
 
    }

    function getInitPrefBroadcastValue(){
        let strSync=sessionStorage.getItem('setpref-broadcast')
        return Boolean(strSync!=='false')
        // return Globals.instance().broadcastMode
    }

    function onChangePrefBroadcast(val) {
        sessionStorage.setItem('setpref-broadcast',JSON.stringify(val))
        // if(Globals.instance().electron){
        //     window.api.send("toApp", {"event":"setpref-broadcast", "pref": val});
        // }
        Globals.instance().broadcastMode = val;
        console.log('onChangePrefBroadcast', val)
        
    }

    function getInitPrefReceiveValue(){
        let strSync=sessionStorage.getItem('setpref-receive')
        return Boolean(strSync!=='false')
        // return Globals.instance().receiveMode
    }

    function onChangePrefReceive(val) {
        sessionStorage.setItem('setpref-receive',JSON.stringify(val))
        // if(Globals.instance().electron){
        //     window.api.send("toApp", {"event":"setpref-broadcast", "pref": val});
        // }
        Globals.instance().receiveMode = val;
        console.log('onChangePrefReceive', val)
        
    }

    function clearControllerIP() {
        ControllerServerComs.instance().postMessageFromControllerToIOS('backToStart','');
    }



    function deleteAccount() {
     
        let comment = {
            username:store.getState().user.username,
            narrative:26,
            location:window.location.hash?window.location.hash.substring(1):window.location.pathname+window.location.search,
            comment:"delete user"
        }
        setLoading(true)
        console.log('comment', comment)
        axios( {
            method: 'post',
            url:Globals.instance().adminAPI+'/api/user-comments-add/',
            data:comment
        }).then(results=>{
            
            setSuccess(true);
            
            
        }).catch(err=>{
            Globals.instance().showAlert('Could not add comment ',err)
            console.error(err)
            setLoading(false)
        })
    }


    function cleariPadCache() {
        setLoading(true);
        gsap.to(ref.current,{duration:0.25,ease:Power3.easeInOut,opacity:0.25});
        window.webkit.messageHandlers.notification.postMessage({ Object: 'clear-ipad-cache' });
      
    }

    function connectToArduino(){
        if(Globals.instance().controllerApp) {
            if (props.userObj && props.userObj.device_sn) {
                ControllerServerComs.instance().sendUDPFromControllerToServer('assign-usb-device', props.userObj.device_sn)
                console.log('passing arduino sn:', props.userObj.device_sn)
            }
        }
    }

    return (
        <React.Fragment>
        <div className={`${styles.settingsContainer}`} ref={ref}>


      
             <div className={`${styles.heading}`}  style={{display: "none"}}>
                <div className={styles.headingTitle}>Syncing</div>
                <Switch onChange={onChangeSync} selected={getInitSyncValue()}></Switch>
                <p>When this is turned off the app will not check for new content when opening narratives</p>
             </div>
             <div className={`${styles.prefs}`}>
             <h2>Settings</h2>

                {!Globals.instance().controllerApp && <div className={`${styles.blockGrid}`}>
                <AccountBlock 
                    icon={props.userObj?<span className={styles.accountBlockAvatar}>{props.userObj.username.charAt(0)}</span>:null}
                    heading={props.userObj?props.userObj.username:""}
                    text={"Manage your account and subscription"}
                    cta={"Account Info"}
                    link={'/account'}
                    target={null}
                    background={"#2B2B2B"}
                    orientation={"vertical"}
                ></AccountBlock>

                {!Globals.instance().controllerApp && !Globals.instance().ios && <AccountBlock 
                    icon={<Pencil />}
                    heading={"Space Studio"}
                    text={"Create and edit your Spaces"}
                    cta={"Open"}
                    link={"https://cms.expostudio.co"}
                    target={"_blank"}
                    background={"#0069A6"}
                    orientation={"vertical"}
                ></AccountBlock>}


                </div>}

                    {Globals.instance().electron && <div className={`${styles.pref}`}>
                    <h3>Launch in Full Screen</h3>
                    <Switch onChange={onChangePrefFullScreen} selected={getInitPrefFullScreenValue()}></Switch>
                    </div>}
           
            <div className={`${styles.pref}`} style={{display: "none"}}>
                <h3>Show Navigation Box</h3>
                <Switch onChange={onChangePrefNavBox} selected={getInitPrefNavBoxValue()}></Switch>
            </div>

           {(Globals.instance().electron || (Globals.instance().ios)) && !Globals.instance().controllerApp && <div className={`${styles.pref}`}>
                <h3>Offline Mode</h3>
                <Switch disabled={Globals.instance().noInternet || props.downloaded === null || props.downloaded.length === 0} onChange={onChangeOfflineMode} selected={getInitOfflineModeValue()}></Switch>
             </div>}
          
            </div>

              <div className={`${styles.buildAbout}`}>
                    <p>Build</p>
                    <p><strong>{Globals.instance().build}</strong></p>
                </div>

             <div className={`${styles.logoutContainer}`}>

             {(Globals.instance().controllerApp || Globals.instance().serverApp) && 
                <React.Fragment>
                <p>Controller using {window.location.host}</p>
                <div className={`round-btn`} onClick={() => clearControllerIP()}> Connect to a new display </div>
               
                {props.userObj && props.userObj.device_sn && <div className={`round-btn`} style={{marginTop: "30px"}}  onClick={() => connectToArduino()}>Connect to Model Lights </div>}
                </React.Fragment>
            }

                <div className={`expo-pill-btn ${getInitOfflineModeValue() ? styles.disabled : ''}`} onClick={getInitOfflineModeValue() ? undefined : logout}> 
                
                {Globals.instance().controllerApp ? "Start Over" : "Logout"}
                
                </div>

               

                  
              


            </div>
     
          
     


        </div>
        {loading && <div style={{position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center"}} >
            <LoaderWheel></LoaderWheel>
        </div>}

    </React.Fragment>            
    )

})


export default Settings

// {(Globals.instance().ios)&&
//     <div className={`round-btn`} style={{marginTop: "30px"}} onClick={() => cleariPadCache()}> Purge Synced Data</div>  }

//   <div className={styles.deletion}>
//                     <h4>Request Account Deletion</h4>
                
//                     <p>Submit a request to delete your account. We will confirm this request and then delete your account. Account deletion will purge the system of all account data. We will email you when that process is complete.</p>
                
//                     {(success)?(<h4>Request successfully submitted</h4>): ((!loading)?<div onClick={deleteAccount} style={{paddingTop: '10px'}}> <u>Delete Account</u></div>:"Sending ...")}
//                 </div>
